import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import utilsService from './services/utilsService';

// Remove trailing slash BEFORE React renders to prevent Safari logout issue
// Safari's ITP (Intelligent Tracking Prevention) can clear storage during certain navigations
// Using window.location.replace to ensure Safari treats this as a same-document navigation
if (
  utilsService.getIsInSafariBrowser() &&
  window.location.pathname !== '/' &&
  window.location.pathname.endsWith('/')
) {
  const newPath =
    window.location.pathname.slice(0, -1) +
    window.location.search +
    window.location.hash;
  window.location.replace(newPath);
} else {
  // eslint-disable-next-line react/no-deprecated
  ReactDOM.render(<App />, document.getElementById('root'));

  //TODO: replace above code with code below (code below uses the new architecture but has issue with some click events in web)
  //const root = ReactDOM.createRoot(document.getElementById('root'));
  //root.render(<App />);

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register('/pingPong-sw.js')
        .then((reg) =>
          console.debug('PingPong Service Worker registered:', reg),
        )
        .catch((err) => console.error('PingPong Service Worker failed:', err));
    });
  }
}
